import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 1815038E-B466-4F5F-91D9-9D03DDA6A9DA
 * name lambda
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lambda.svg
 * tags
 * - Gaming / RPG 
 * - Math 
 */
export const LambdaIcon = createSvgIcon(<><path d="M6,20L10.16,7.91L9.34,6H8V4H10C10.42,4 10.78,4.26 10.93,4.63L16.66,18H18V20H16C15.57,20 15.21,19.73 15.07,19.36L11.33,10.65L8.12,20H6Z" /></>, 'LambdaIcon');
export default LambdaIcon